// Shared, reusable className tokens so styling lives in one place.

// Inline text-link style used across pages and MDX-rendered content.
export const linkClass =
  'underline decoration-[0.64px] underline-offset-4 text-[var(--text-primary)] hover:opacity-70 transition-opacity'
